export default "__VITE_ASSET__CvYEL$3e__"